export default __webpack_public_path__ + "static/media/thrive.0f900263.jpg";